import React from "react";
import "../styles/CartErrorPopup.css";

const CartErrorPopup = ({ isOpen, onClose, message }) => {
    if (!isOpen) return null;

    return (
        <div className="cart-popup-overlay">
            <div className="cart-popup-container">
                <p className="cart-popup-message">{message}</p>
                <button className="cart-popup-close" onClick={onClose}>확인</button>
            </div>
        </div>
    );
};

export default CartErrorPopup;
